import { UserAuthProviderResponse, UserProviderProfile } from "recoil/types";

/**
 * Custom function to get sanitized user data from recoil state.
 * Ensures boolean-like flags are converted to 'true' or 'false' strings,
 * handling undefined appropriately by defaulting to false.
 */
export const getSanitizedProviderData = (auth: UserAuthProviderResponse) => ({
  date_joined: auth.date_joined || "",
  is_electronic_ordering_enabled:
    String(auth.is_electronic_ordering_enabled) || "",
  release_to_patient_enabled: String(auth.release_to_patient_enabled) || "",
  user_type: auth.user_type || "",
  show_client_warning: String(auth.show_client_warning) || "",
  default_npi: auth.default_provider_info?.default_npi || "",
});

/**
 * Provider profile context for feature flag targeting and analytics (e.g. lims_id).
 * Analogous to the patient portal's `getDetailedUserData`.
 */
export const getDetailedProviderData = (profile?: UserProviderProfile) => ({
  lims_id: profile?.account.lims_id || "",
});
